import isEmpty from 'lodash/isEmpty.js';
import map from 'lodash/map.js';

import axios from '@/plugins/axios.js';
import { promiseError } from '@/store/utilities/Helpers.js';

export default {
    state: {
        students: null,
    },

    getters: {
        get: state => state.students,
    },

    actions: {
        async fetch(context, courseId) {
            try {
                const { data } = await axios.get(`/api/course-enrollments?filter[course_id]=${courseId}&per_page=100`);
                const instructor = map(
                    data.data.filter(user => user.roles.some(role => role.name === 'Instructor')),
                    'user'
                );
                const students = map(
                    data.data.filter(user => user.roles.some(role => role.name === 'Student')),
                    'user'
                );

                if (!isEmpty(instructor)) {
                    context.commit(
                        `Courses/${courseId}/EDIT`,
                        {
                            property: 'instructor',
                            value: instructor[0],
                        },
                        {
                            root: true,
                        }
                    );
                }

                context.commit('hydrate', students);

                return students;
            } catch (error) {
                promiseError({
                    key: 'student_list_error',
                    context,
                });

                return error;
            }
        },
    },

    mutations: {
        hydrate(state, payload) {
            state.students = payload;
        },
    },
};
